import { Link, useLocation } from 'react-router-dom';
import { cn } from '../../lib/utils';
import {
  LayoutDashboard,
  FileText,
  HandHeart,
  Sparkles,
  BookOpen,
  FolderKanban,
  Layers,
  Tag,
  ImageIcon,
  Settings,
  MessageSquareQuote,
  X,
} from 'lucide-react';

const navigation = [
  { name: 'Dashboard', href: '/', icon: LayoutDashboard },
  { name: 'Pages', href: '/pages', icon: FileText },
  { name: 'Massages', href: '/massages', icon: HandHeart },
  { name: 'Soins', href: '/soins', icon: Sparkles },
  { name: 'Catégories services', href: '/service-categories', icon: Layers },
  { name: 'Articles', href: '/articles', icon: BookOpen },
  { name: 'Catégories articles', href: '/categories', icon: FolderKanban },
  { name: 'Tags', href: '/tags', icon: Tag },
  { name: 'Témoignages', href: '/testimonials', icon: MessageSquareQuote },
  { name: 'Média', href: '/media', icon: ImageIcon },
  { name: 'Paramètres', href: '/settings', icon: Settings },
];

interface SidebarProps {
  onClose?: () => void;
}

export function Sidebar({ onClose }: SidebarProps) {
  const location = useLocation();

  return (
    <div className="flex h-full w-64 flex-col bg-spa-cream border-r border-spa-gold/20">
      {/* Logo + Close button for mobile */}
      <div className="flex h-16 items-center justify-between px-6 border-b border-spa-gold/20">
        <img
          src="/logo.png"
          alt="Univers Massages"
          className="h-10 sm:h-12 w-auto object-contain"
        />
        {/* Close button - only visible on mobile */}
        {onClose && (
          <button
            onClick={onClose}
            className="lg:hidden p-2 rounded-md hover:bg-spa-gold/20 transition-colors"
            aria-label="Fermer le menu"
          >
            <X className="h-5 w-5 text-gray-700" />
          </button>
        )}
      </div>

      {/* Navigation */}
      <nav className="flex-1 space-y-1 px-3 py-4 overflow-y-auto">
        {navigation.map((item) => {
          const isActive = location.pathname === item.href;
          return (
            <Link
              key={item.name}
              to={item.href}
              onClick={onClose}
              className={cn(
                'group flex items-center px-3 py-2.5 text-sm font-medium transition-colors rounded-md',
                isActive
                  ? 'bg-spa-gold text-white'
                  : 'text-gray-700 hover:bg-spa-gold/20 hover:text-gray-900'
              )}
            >
              <item.icon
                className={cn(
                  'mr-3 h-5 w-5 flex-shrink-0',
                  isActive ? 'text-white' : 'text-spa-gold group-hover:text-spa-gold'
                )}
              />
              {item.name}
            </Link>
          );
        })}
      </nav>

      {/* Footer */}
      <div className="border-t border-spa-gold/20 p-4">
        <p className="text-xs text-gray-600 text-center font-serif italic">
          Univers Massages CMS
        </p>
      </div>
    </div>
  );
}
